require('../scss/browser-support.scss')
require('../favicon.png')
require('../assets/images/logoChrome.png')
require('../assets/images/logoEdge.png')
require('../assets/images/capital-one-logo.svg')
require('../assets/images/DN_compact.svg')
